import { Component, input, OnChanges } from '@angular/core';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TPushNotification } from '../../notification.model';
import { ENotificationType } from '../notification-type.enum';

@Component({
    selector: 'pp-notification-reminder',
    templateUrl: './notification-reminder.component.html',
    styleUrl: './notification-reminder.component.scss',
    standalone: false
})
export class NotificationReminderComponent implements OnChanges {
  ppNotification = input<TPushNotification>();

  EIconPath = EIconPath;
  notificationText: string;
  notificationTextBlue: string;
  appliedDeletedStyle = false;

  constructor(private translationPipe: TranslationPipe) {}

  ngOnChanges(): void {
    switch (this.ppNotification().pushNotificationType) {
      case ENotificationType.REMINDER_CREATED_FOR:
        this.notificationTextBlue = this.translationPipe.transform(
          'notification_reminder_created_for_1',
        );

        this.notificationText = this.translationPipe.transform(
          'notification_reminder_created_for_2',
        );

        this.appliedDeletedStyle = false;
        break;
      case ENotificationType.REMINDER_EDITED_FOR:
        this.notificationTextBlue = this.translationPipe.transform(
          'notification_reminder_edited_for_1',
        );
        this.notificationText = this.translationPipe.transform(
          'notification_reminder_edited_for_2',
        );

        this.appliedDeletedStyle = false;
        break;
      case ENotificationType.REMINDER_DELETED_FOR:
        this.notificationTextBlue = this.translationPipe.transform(
          'notification_reminder_deleted_for_1',
        );
        this.notificationText = this.translationPipe.transform(
          'notification_reminder_deleted_for_2',
        );

        this.appliedDeletedStyle = true;
        break;
      case ENotificationType.REMINDER_DELETED_BY_ASSIGNEE:
        this.notificationTextBlue = this.translationPipe.transform(
          'notification_reminder_deleted_by_assignee_1',
        );

        this.notificationText = this.translationPipe.transform(
          'notification_reminder_deleted_by_assignee_2',
        );

        this.appliedDeletedStyle = true;
        break;
      default:
        this.notificationText = '';
        this.notificationTextBlue = '';
        this.appliedDeletedStyle = false;
        break;
    }
  }
}
